const tabs = () => {
    const tabs = document.querySelectorAll('.tabs');
    const tabsContent = document.querySelectorAll('.upload-form');

    tabs && [...tabs].forEach( tab => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            const tabEl = e.target;
            const tabType = tabEl.dataset.tab;

            [...tabs].forEach( tab => tab.classList.remove('active'));

            tab.classList.add('active');

            [...tabsContent].forEach( content => {
                content.classList.remove('active');

                if( content.dataset.tab === tabType ) {
                    content.classList.add('active');
                }
            })
        }, true);
    })

}

export default tabs;